import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withEinstein from '../../withEinstein/containers/withEinstein';
import CartRecommendations from '../components/CartRecommendations';
import EmptyCartRecommendations from '../components/EmptyCartRecommendations';


class CartRecommendedProducts extends Component {
  static getDomId() {
    return 'slot_cart_recommended_products';
  }

  static getFallbackDetails() {
    return {
      delay: 0,
      url: `${window.seMarketplace.site_globals.profferUrl}?type=cartRecommendations`,
    };
  }

  constructor(props) {
    super(props);
    this.homeURL = window.seMarketplace.site_globals.homeURL;
  }

  render() {
    const {
      details,
      emptyCart,
      productLimit,
      recommendedProducts,
    } = this.props;
    const ctaButton = (recommendedProducts.length > 0 && details.cta) || { displayText: 'Continue shopping', url: this.homeURL };

    if (emptyCart) {
      return (
        <EmptyCartRecommendations
          title={details.title}
          products={recommendedProducts}
          ctaButton={ctaButton}
          productLimit={productLimit}
        />
      );
    }

    return (
      <CartRecommendations
        title={details.title}
        products={recommendedProducts}
        ctaButton={ctaButton}
        productLimit={productLimit}
      />
    );
  }
}

CartRecommendedProducts.propTypes = {
  details: PropTypes.shape({}),
  recommendedProducts: PropTypes.arrayOf(PropTypes.shape({
    productID: PropTypes.string,
  })),
  fallbackProducts: PropTypes.shape({
    productIds: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  productLimit: PropTypes.number.isRequired,
  emptyCart: PropTypes.bool,
};

CartRecommendedProducts.defaultProps = {
  emptyCart: false,
  details: { title: 'Don\'t miss out on these deals' },
  fallbackProducts: undefined,
  recommendedProducts: [],
};

export default withEinstein(CartRecommendedProducts);
